import React from 'react';
import { DateTime } from 'luxon';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import BankIcon from '@material-ui/icons/AccountBalance';
import AmexIcon from 'app/components/icons/Amex';
import VisaIcon from 'app/components/icons/Visa';
import MasterCardIcon from 'app/components/icons/MasterCard';
import DiscoverIcon from 'app/components/icons/Discover';
import CreditCardIcon from '@material-ui/icons/CreditCard';

import Months from 'app/utils/Months';

const PaymentMethodItem = props => {

    const { method, defaultMethod, openEditPaymentMethodDialog } = props;

    const getCardIcon = brand => {
        switch (brand) {
            case 'amex': return <AmexIcon/>;
            case 'visa': return <VisaIcon/>;
            case 'mastercard': return <MasterCardIcon/>;
            case 'discover': return <DiscoverIcon/>;
            default: return <CreditCardIcon/>;
        }
    }

    const editPaymentMethod = () => openEditPaymentMethodDialog(method);

    switch (method.type) {
        case 'card': return (
            <ListItem
                button
                onClick={editPaymentMethod}
                >
                <ListItemIcon>
                    {getCardIcon(method.card.brand)}
                </ListItemIcon>
                <ListItemText>
                    <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <Typography variant="subtitle1" display="inline">
                                {window.ucFirst(method.card.brand)}&nbsp;&nbsp;&#9679;&#9679;&#9679;&#9679;&nbsp;&nbsp;{method.card.last4}
                            </Typography>
                            <Typography variant="body1" display="inline" color="primary">
                                {(method.id === defaultMethod) ? ' - Default' : null}
                            </Typography>
                        </Grid>
                        <Grid item>
                            {(DateTime.fromObject({
                                year: method.card.exp_year,
                                month: method.card.exp_month
                            }) > DateTime.local()) ? (
                                <Typography variant="subtitle2" color="textSecondary">
                                    {`Expires ${Months[method.card.exp_month].full} ${method.card.exp_year}`}
                                </Typography>
                            ) : (
                                <Typography variant="subtitle2" color="error">
                                    {`Expired ${Months[method.card.exp_month].full} ${method.card.exp_year}`}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </ListItemText>
            </ListItem>
        )

        case 'us_bank_account': return (
            <ListItem
                key={method.id}
                button
                onClick={editPaymentMethod}
                >
                <ListItemIcon>
                    <BankIcon/>
                </ListItemIcon>
                <ListItemText>
                    <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <Typography variant="subtitle1" display="inline">
                                {window.ucFirst(method.us_bank_account.bank_name)}&nbsp;&nbsp;&#9679;&#9679;&#9679;&#9679;&nbsp;&nbsp;{method.us_bank_account.last4}
                            </Typography>
                            <Typography variant="body1" display="inline" color="primary">
                                {(method.id === defaultMethod) ? ' - Default' : null}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle2" color="textSecondary">
                                USD
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItemText>
            </ListItem>
        )
    }
}

export default PaymentMethodItem;